import type { StagingStatus } from '../../schema';

const LABELS: Record<StagingStatus, string> = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  EDITED: 'Edited',
  REJECTED: 'Rejected',
  SUPERSEDED: 'Superseded',
};

const TONE: Record<StagingStatus, string> = {
  PENDING: 'bg-warning/[0.12] text-warning',
  APPROVED: 'bg-success/[0.14] text-success',
  EDITED: 'bg-primary/[0.12] text-primary',
  REJECTED: 'bg-error/[0.12] text-error',
  SUPERSEDED: 'bg-foreground-muted/[0.14] text-foreground-muted',
};

export function StatusBadge({ status }: { status: StagingStatus }) {
  return (
    <span className="inline-flex h-full items-center">
      <span
        className={`inline-flex h-[20px] items-center rounded-full px-2 text-[11px] font-semibold uppercase tracking-wide ${TONE[status]}`}
      >
        {LABELS[status]}
      </span>
    </span>
  );
}
